import React, { useEffect, useState } from 'react';

import { Menu } from '@progress/kendo-react-layout';

import Button from '@material-ui/core/Button';
import Tooltip from '@material-ui/core/Tooltip';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';

import { bob } from '../data/tabs';

import classes from './ViewSelector.module.css';

const TabViewSelector = ({
    activeTab,
    activeView,
    handleChangeView,
    overviewPage,
    ...props
}) => {
    const [viewItems, setviewItems] = useState([]);
    const [anchorEl, setAnchorEl] = useState(null);
    const [menuOpen, setMenuOpen] = useState(false);

    const open = Boolean(anchorEl);
    const id = open ? 'nav-select-popover' : undefined;

    useEffect(() => {
        let tabList = [];
        let viewList = [];
        if (process.env.siteScoringEnabled) {
            tabList = bob[overviewPage].tabs;
        }
        else {
            // remove the scoring view
            tabList = bob[overviewPage].tabs.filter(tab => tab.key !== '15dfff21-071c-4ee6-ab53-903fdcb5996a');
        }

        if (process.env.contactsEnabled) {
            tabList = bob[overviewPage].tabs;
        } else {
            // remove the contact views
            tabList = bob[overviewPage].tabs.filter(tab => tab.key !== 'f93bff85-c8cf-4dcf-a64a-a499b927c58b' && tab.key !== '517558d4-c3f4-417d-a2d2-c10ec2f6cf2f');
        }

        // remove executive summary from view selector
        tabList = bob[overviewPage].tabs.filter(tab => tab.key !== 'c4f4919e-e301-4730-a5b8-dc1edbef6cb7');

        if (!process.env.showSiteFaultsView && overviewPage === 'site') {
            tabList = bob[overviewPage].tabs.filter(tab => tab.key !== '25fgdf16-171c-4ee6-a753-913fdcb5457b');
        }

        tabList.forEach(tab => {
            let childViewList = [];
            if (tab.views) {
                tab.views.forEach(childView => {
                    childViewList.push( 
                        { 
                            'viewParentId': tab.key,
                            'key':          childView.key, 
                            'text':         childView.title,
                            'cssClass':     classes.menuItem
                        });
                });
            }
            viewList.push( 
                { 
                    'key':      tab.key, 
                    'text':     tab.title === 'Health Monitor' ? tab.title : tab.title.split(' ')[0],
                    'items':    childViewList,
                    'cssClass': classes.menuItem
                });
        });

        setviewItems(viewList);
    },[]);

    const handleClick = event => {
        setAnchorEl(event.currentTarget);
        setMenuOpen(!menuOpen);
    };

    const handleClose = () => {
        setAnchorEl(null);
        setMenuOpen(false);
    };

    const onViewSelect = (e) => {
        const { item: view } = e;
        handleChangeView(view);
        setAnchorEl(null);
        setMenuOpen(false);
    };
    
    let viewName = activeView;
    if (activeView === 'sensorgraph') {
        viewName = 'sensor graph';
    } else if (activeView ==='sensorgrid') {
        viewName = 'sensor grid';
    } else if (activeView ==='scoregraph') {
        viewName = 'score graph';
    } else if (activeView ==='scoregrid') {
        viewName = 'score grid';
    }

    return (
        <ClickAwayListener
            onClickAway={() => handleClose(false)}
        >
            <div className={classes.Popper}>
                <Button
                    className={classes.Button}
                    aria-describedby={id}
                    onClick={handleClick}
                >
                    <Tooltip
                        classes={{ tooltip: classes.tooltip }}
                        title=""
                        placement="bottom"
                    >
                        <div className={classes.Selector}>
                            <p>View - {activeTab} { activeView ? `- ${viewName}` : ''} <i className={`fas fa-chevron-${menuOpen ? 'down' : 'up'}`} aria-hidden="true" /></p>
                        </div>
                    </Tooltip> 
                </Button>
                { open && menuOpen ? 
                    <div className={classes.customPopover}>
                        <Menu
                            items={viewItems}
                            vertical={true}
                            onSelect={onViewSelect}
                        />
                    </div>
                    : null
                }
            </div>
        </ClickAwayListener>
    );
};

export default TabViewSelector;
